import React from 'react';
import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';

const ContentCard = ({ children }) => (
  <Card className="general-customizer__container__card">
    <CardBody>{children}</CardBody>
  </Card>
);

ContentCard.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default ContentCard;
